import { useState } from 'react'

import { TwoFaModalTitle } from './two-fa-modal-title.component'
import { TwoFANone } from './none'
import { Totp2FA } from './totp'
import { Email2FA } from './email'
import { useMe } from 'src/hooks'
import { E2FATab, E2FAMethod } from 'src/types'

import { useStyles } from './styles'

const TwoFAModalInner = () => {
  const classes = useStyles()
  const { data: me } = useMe()
  const [tab, setTab] = useState<E2FATab>(
    me?.two_factor_method === E2FAMethod.Totp
      ? E2FATab.Totp
      : me?.two_factor_method === E2FAMethod.Email
        ? E2FATab.Email
        : E2FATab.None,
  )

  if (!me) return null

  const method = me.two_factor_method
  const twoFARequired = me.two_factor_required

  return (
    <>
      <TwoFaModalTitle faRequired={twoFARequired} tab={tab} setFaMethod={setTab} method={method} />
      <div className={classes.tabContainer}>
        <Email2FA tab={tab} method={method} />
        <TwoFANone tab={tab} />
        <Totp2FA tab={tab} method={method} />
      </div>
    </>
  )
}

export { TwoFAModalInner }
